__turbopack_context__.v({
  "button": "AmountSelection-module__-Ni0xG__button",
  "fieldset": "AmountSelection-module__-Ni0xG__fieldset",
  "flex": "AmountSelection-module__-Ni0xG__flex",
  "input": "AmountSelection-module__-Ni0xG__input",
  "inputWrapper": "AmountSelection-module__-Ni0xG__inputWrapper",
  "radio": "AmountSelection-module__-Ni0xG__radio",
});
